import { useContext } from 'react';
import { NotificationContext, type NotificationContextValue } from './notificationContext';

export const useNotifications = (): NotificationContextValue => {
  return useContext(NotificationContext);
};
